import { TopDialogUtils } from './utils';
import { TopDialogWorker } from './worker';
import { querySelectorVisible } from '@/core/utils/dom';
import type { $el } from '@/components/types';
import { historySetState } from '@/core/utils/route';

let inited = false;

/**
 * Инициализация глобальных событий для диалоговых окон
 *
 * Проивзодится один раз при подклчюении диалогового окна
 *
 * События не размонитруются
 */
export const initDialogGlobalEvents = () => {
	if (inited) return;
	inited = true;

	/**
	 * Закрытие диалога по Esc
	 */
	document.addEventListener('keydown', (e) => {
		if (e.key !== 'Escape') return;
		if (!e.target) return;

		const el = e.target as HTMLElement;

		// событие произошло вне диалогового окна
		if (!el.closest('.ui-dialog')) return;

		if (el.contentEditable === 'true' || el.contentEditable === 'plaintext-only') return;

		// не закрывать окно при открытом TopPopup
		if (querySelectorVisible(document.documentElement, '.top-popup-wrapper')) return;

		// не закрывать окно при работе с jquery autocomplete
		if (el.classList.contains('autocomplete')) return;

		// не закрывать окно при открытом fancybox
		if (querySelectorVisible(document.documentElement, '.fancybox-container')) return;

		$('.ui-dialog-content:visible:last').dialog('close');
	});

	/**
	 * Закрытие диалога по кнопке закрыть
	 */
	$(document).on('click', '[data-action="top-dialog-close"]', (e) => {
		e.preventDefault();

		// // навигация без истории
		// var $dialog = $(this).closest('.ui-dialog-content');
		// var viewName = $dialog.attr('id');
		// var pageName = getHash('view-' + viewName);
		// if (!pageName) {
		// 	toPrevPage($dialog);
		//
		// 	return;
		// }
		//
		// // навигация по истории
		// if (Core.state.isMobile && history.length > 1 && $(this).closest('.modal-layer').length) {
		// 	var href = location.href;
		//
		// 	history.go(-1);
		//
		// 	setTimeout(() => {
		// 		// это первая страница в истории вкладки браузера
		// 		if (href === location.href) $(e.target).closest('.ui-dialog-content').dialog('close');
		// 	});
		// } else {
		// 	$(this).closest('.ui-dialog-content').dialog('close');
		// }

		const el = e.target.closest('[data-action="top-dialog-close"]');

		const elDialog = el.closest('.ui-dialog-content');
		if (!elDialog) return;

		const $dialog = $(elDialog);

		// если к кнопке привязана ссылка, диалоговое окно не нужно закрывать
		const toView = el.dataset.toView;

		if (toView == 'toPrevPage()') {
			TopDialogUtils.toPrevPage($dialog);

			return;
		}

		if (toView) {
			const viewNameAndPageLink = toView.split('-');
			const viewName = viewNameAndPageLink.shift();
			const pageLink = viewNameAndPageLink.join('-');

			const $toDialog = $('#' + viewName);
			const $toPage = $('[data-view-page="' + pageLink + '"]', $toDialog);
			if (!$toPage.is(':visible')) {
				const hash = TopDialogWorker.genViewPageHash(toView, 'prev');

				// // не убирает кнопку "Вперед" в браузере
				// history.replaceState(null, '', hash);
				// toViewDirty(toView, 'prev');

				// // добавляет текущую страницу в историю браузера
				historySetState(false, hash);

				return;
			}
		}

		$dialog.dialog('close');
	});

	/**
	 * Все submit должны обрабатываться через js
	 */
	$(document).on('submit', '.modal-body > form, .modal-layer-body > form', function (e) {
		e.preventDefault();
	});

	/**
	 * Выполнение действия по нажатию Enter
	 *
	 * @todo Убрать `.searcher`
	 */
	$(document).on('keypress', '.ui-dialog .modal-body :input:not(.searcher), .ui-dialog .modal-body [contenteditable]', function (e) {
		// if (e.keyCode !== 10 && e.key !== 'ENTER') return;
		if (e.key !== 'ENTER') return;

		// не выполнять submit действий при работе с jquery autocomplete
		if (e.target.classList.contains('autocomplete')) {
			e.preventDefault();

			return;
		}

		// реализация submit по ctrl + Enter
		if (e.target.tagName === 'TEXTAREA') {
			if (!e.ctrlKey && !e.metaKey) return;

			const elForm = e.target.closest('form');

			if (elForm) {
				let elSubmit = $(':submit:visible', elForm)[0];
				if (!elSubmit) elSubmit = $(':submit:visible', elForm)[0];

				elSubmit?.click();
			}
		}
	});

	/**
	 * Закрытие диалога по клику вне окна
	 */
	$(document).on('click', '.ui-widget-overlay', function () {
		let $dialogWrapper: $el | undefined = undefined;
		let topZIndex = 0;

		$('.ui-dialog:visible').each((_index, el) => {
			const zIndex = Number($(el).css('z-index'));
			if (zIndex < topZIndex) return;

			$dialogWrapper = $(el);
			topZIndex = zIndex;
		});

		if ($dialogWrapper) {
			$('.ui-dialog-content', $dialogWrapper).dialog('close');
		}
	});

	$(window).on('resize', TopDialogUtils.recalcPositions);
	TopDialogUtils.recalcPositions();
};
